const withdrawStatus = {
  idle: "idle",
  success: "Selesai",
  do: "Diproses",
  reject: "Gagal",
};

export default withdrawStatus;
